import React from 'react';
import { useLang } from '../components/LanguageProvider';
import translations from '../translations';
import ConstellationGrid from '../components/cloud/ConstellationGrid';
import OrbitalMap from '../components/cloud/OrbitalMap';

/**
 * WHOWSELL CLOUD (/whowsell-cloud)
 *
 * Kaynak: radar-whowsell/components/cloud/cloud-page.tsx
 * (crm-whowsell/src/components/cloud/CloudPage.tsx, ai-whowsell/app/
 * whowsell-cloud/cloud-content.tsx ve server-whowsell/src/app/
 * whowsell-cloud/page.tsx ile bölüm bölüm aynı sayfa)
 *
 * Bölüm düzeni kaynaktan birebir: arka planda takımyıldız ağı ·
 * rozet · "düz kısım + gradyanlı vurgu" başlığı · alt başlık ·
 * yörünge haritası · ipucu satırı.
 *
 * SAPMALAR VE GEREKÇELERİ
 *  1. Kaynak Next.js/TS; burada CRA + saf JS. `'use client'`, `next/image`
 *     ve `<style jsx>` yok.
 *  2. Kaynak sayfayı `PageFrame` (üst şerit + altbilgi) sarıyor. Bu
 *     projede üst şerit ve altbilgi App.js'te, rotanın DIŞINDA duruyor;
 *     o yüzden burada yalnızca sayfanın gövdesi var.
 *  3. Kaynaktaki `Reveal` (kaydırınca beliren sarmalayıcı) kullanılmadı.
 *     Bu projedeki karşılığı `SectionReveal` içeriğin üstüne 200px'lik bir
 *     ayraç çizgisi çiziyor — ana sayfanın bölüm ayracı için doğru, tek
 *     başlık için yanlış olurdu. Aynı karar AboutPage'te de verilmişti.
 *  4. Kaynak kendi CSS değişkenlerini (--crm-*, --wh-*, --ws-*) kullanıyor;
 *     bunlar burada yok. Renkler App.css'teki `.wh-cloud` bloğunda bu
 *     sitenin koyu/açık tema desenine çevrildi.
 */
export default function CloudPage() {
  const { lang } = useLang();
  const t = translations[lang].cloud;

  return (
    <main className="wh-cloud">
      <ConstellationGrid />
      <div className="wh-cloud-inner">
        <div className="wh-cloud-head">
          <span className="wh-cloud-badge">{t.badge}</span>
          <h1 className="wh-cloud-title">
            {t.titlePre}
            <span className="animated-gradient-text">{t.titleAccent}</span>
          </h1>
          <p className="wh-cloud-sub">{t.subtitle}</p>
        </div>

        <OrbitalMap />

        <p className="wh-cloud-hint">{t.hint}</p>
      </div>
    </main>
  );
}
